export default "__VITE_ASSET__DlubOUHa__"